import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Card, Button, Table, Row, Col } from "react-bootstrap";
import ChartsContext from "contexts/ChartsContext";

const PerfectAttendees = ({ handleCSVDownload, handleTableClose }) => {
    const { updateTime, setUpdateTime } = useContext(ChartsContext);
    const [perfectAttendees, setPerfectAttendees] = useState([]);  // State to store the Perfect Attendees data
    console.log("Perfect Attendees" + perfectAttendees);
    const fetchPerfectAttendees = () => {
        axios.get(`${process.env.REACT_APP_SERVER_URL}/event/getPerfectAttendees`)
            .then(response => {
                console.log("perfect attendance"+response.data);
                setPerfectAttendees(response.data);  // Store the Perfect Attendees data in state
                const currentTime = new Date().toLocaleString();
                setUpdateTime(currentTime);
            })
            .catch(error => {
                console.error("Error fetching Perfect Attendees:", error);
            });
    };

    useEffect(() => {
        fetchPerfectAttendees();
    }, []);

    return (
        <>
            <Card className="card-stats">
                <Card.Header>
                    <Row>
                        <Col>
                            <Card.Title as="h4">全勤居士名单</Card.Title>
                            <p className="card-category">Full Attendance List</p>
                        </Col>
                        <Col className="text-right">
                            <Button variant="info" onClick={() => handleCSVDownload(perfectAttendees, 'perfectAttendees')} className='mr-3'>
                                Download to CSV
                            </Button>
                            <Button variant="danger" onClick={handleTableClose}>
                                Close Table
                            </Button>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Table className="table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Guest ID</th>
                                <th>Name</th>
                                <th>Chinese Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Registration Time</th>
                                <th>Check-in Time</th>
                                {/* Check-in Fields */}
                                {/* <th>Check-in 8/9 9:30</th>
                                <th>Check-in 8/9 13:30</th>
                                <th>Check-in 15/9 9:30</th>
                                <th>Check-in 22/9 9:30</th>
                                <th>Check-in 29/9 9:30</th>
                                <th>Check-in 6/10 9:30</th>
                                <th>Check-in 13/10 9:30</th>
                                <th>Check-in 20/10 9:30</th>
                                <th>Check-in 27/10 9:30</th>
                                <th>Check-in 27/10 13:30</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {perfectAttendees.map((perfectAttendee) => (
                                <tr key={perfectAttendee.id}>
                                    <td>{perfectAttendee.id}</td>
                                    <td>
                                        {perfectAttendee.firstname} {perfectAttendee.lastname}
                                    </td>
                                    <td>{perfectAttendee.chinesename || 'N/A'}</td>
                                    <td>{perfectAttendee.phone}</td>
                                    <td>{perfectAttendee.email}</td>
                                    <td>
                                        {new Date(perfectAttendee.registrationTime).toLocaleString()}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkedInTime
                                            ? new Date(perfectAttendee.checkedInTime).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    {/* Check-in Fields */}
                                    {/* <td>
                                        {perfectAttendee.checkin_8_9_9_30
                                            ? new Date(perfectAttendee.checkin_8_9_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_8_9_13_30
                                            ? new Date(perfectAttendee.checkin_8_9_13_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_15_9_9_30
                                            ? new Date(perfectAttendee.checkin_15_9_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_22_9_9_30
                                            ? new Date(perfectAttendee.checkin_22_9_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_29_9_9_30
                                            ? new Date(perfectAttendee.checkin_29_9_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_6_10_9_30
                                            ? new Date(perfectAttendee.checkin_6_10_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_13_10_9_30
                                            ? new Date(perfectAttendee.checkin_13_10_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_20_10_9_30
                                            ? new Date(perfectAttendee.checkin_20_10_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_27_10_9_30
                                            ? new Date(perfectAttendee.checkin_27_10_9_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td>
                                    <td>
                                        {perfectAttendee.checkin_27_10_13_30
                                            ? new Date(perfectAttendee.checkin_27_10_13_30).toLocaleString()
                                            : 'Not Checked in Yet'}
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
                <Card.Footer>
                    <hr />
                    <div className="stats">
                        <i className="fas fa-redo mr-1"></i>
                        Updated at <span className="font-weight-bold">{updateTime}</span>
                    </div>
                </Card.Footer>
            </Card>
        </>
    );
}

export default PerfectAttendees;
